import { devInstance } from "../axios/axiosInstance";

export interface SpecialTokenRequest {
    meterId: string;
    subclass: number;
    messageId: string;
    supp: number;
}

export interface UpdateMeterKeyRequest {
    meterId: string;
    messageId: string;
}

export interface SpecialTokenResponse {
    customerName: string;
    address: string;
    meterNo: string;
    reason: string;
    operatorId: string;
    printedOn: string;
    transactionDate: string;
    tokenType: string;
    tokenDec?: string;
    tokenHex?: string;
    tokenDec_1?: string;
    tokenDec_2?: string;
    keyChangeRequired?: boolean;
    numTokens?: number;
    description?: string;
    [key: string]: unknown;
}

export const processSpecialToken = async (payload: SpecialTokenRequest) => {
    const response = await devInstance.post('/prismvending/vendMeterSpecificEngineeringToken', payload)
    return response
}

export const updateMeterKey = async (payload: UpdateMeterKeyRequest) => {
    const response = await devInstance.post('/prismvending/UpdateMeterKey', payload)
    return response
}

export const submitSpecialToken = (payload: SpecialTokenRequest) =>
    payload.subclass === 3
        ? updateMeterKey({ meterId: payload.meterId, messageId: payload.messageId })
        : processSpecialToken(payload)